<template>
  <div class="mt-72 flex flex-col md:flex-row-reverse">
    <RevLink
      v-if="hasSupportFeatureEnabled"
      class="mb-16 md:mb-0 md:ml-16"
      :to="SUPPORT_CENTER_LINK"
    >
      {{ i18n(translations.sellerSupportCenter) }}
    </RevLink>

    <RevLink class="mb-16 md:mb-0 md:ml-16" :to="QUALITY_CHARTER_LINK">
      {{ i18n(translations.qualityCharter) }}
    </RevLink>

    <RevLink class="mb-16 md:mb-0" :to="TERMS_AND_CONDITIONS_LINK">
      {{ i18n(translations.termAndConditions) }}
    </RevLink>

    <div class="body-1-bold flex-1">
      {{
        i18n(translations.copyright, {
          date: new Date().getFullYear(),
        })
      }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'

import { getExternalLinkList } from '~/constants/externalLinks'
import { useBusinessFeaturesStore } from '~/scopes/config/stores/businessFeaturesStore'

import translations from './TheFooter.translations'

const i18n = useI18n()

const { isFeatureEnabled } = useBusinessFeaturesStore()
const hasSupportFeatureEnabled = isFeatureEnabled('supportEnabled')
const { SUPPORT_CENTER_LINK, QUALITY_CHARTER_LINK, TERMS_AND_CONDITIONS_LINK } =
  getExternalLinkList(i18n.currentLocale)
</script>
